import router from "@/router";
export default {
  namespaced: true,
  state: {
    micIndex: -1,
    certificateNameStatus: "",
    loadingGIF: false,
    themeLoader: 0,
    themeInterval: 0,
    loading: false,
    orderSummary: {
      visible: false,
      persistent: false,
      userId: "",
      transactionId: "",
      doctorName: "",
      doctorSpeciality: "",
      appointmentType: "",
      addressName: "",
      address: "",
      transactions: [],
      newModal: false
    },
    search: {
      relifeMember: false,
      speciality: 0,
      complain: null,
      complains: [],
      filterType: "",
      specialityText: "",
      page: 1,
      drName: ""
    },
    appointmentListing: {
      currentDate: "",
      currentSearchName: "",
      currentType: "",
      currentClinic: "",
      currentDateCleared: false,
      completedDate: "",
      completedSearchName: "",
      completedType: "",
      completedClinic: "",
      completedDateCleared: false,
      cancelledDate: "",
      cancelledSearchName: "",
      cancelledType: "",
      cancelledClinic: "",
      cancelledDateCleared: false,
      allDate: "",
      allSearchName: "",
      allType: "",
      allClinic: "",
      allDateCleared: false
    },
    hospitalSearch: {
      isRelifeMember: false,
      // isVerified: false,
      hospitalType: "",
      specialityType: "",
      specialityText: "",
      facilityType: [],
      diseaseType: "",
      diseaseText: "",
      advanceFilter: "",
      page: 1
    },
    diagnosticSearch: {
      relifeMember: false,
      isVerified: false,
      diagnosticType: "",
      diagnosticValues: [],
      diagnosticAdvanceFilters: []
    },
    bloodbankCampSearch: {
      relifeMember: false,
      isVerified: false,
      page: 1,
      bloodBankType: null,
      advanceFilter: "center",
      searchText: "",
      records_per_page: 10
    },
    bloodBankRequestBlood: {
      routeTobloodBank: false,
      requisitionForm: {
        hospital_name: "",
        first_name: "",
        last_name: "",
        blood_group: "",
        components_list: [],
        upload_form: ""
      },
      search_filter: {
        relifeMember: false,
        isVerified: false,
        page: 1,
        search_query: "",
        records_per_page: 10,
        bloodBankType: null,
        advanceFilter: [],
        componentName: []
      }
    },
    fromoc: {
      filterType: "",
      page: 1
    },
    snack: {
      snackbar: false,
      // snackbarColor: "white",
      timeout: 3000,
      bottom: true,
      right: false,
      top: false,
      left: false,
      message: ""
    }
  },
  getters: {
    orderSummaryModal(state) {
      return state.orderSummary;
    },
    getSnackbar(state) {
      return state.snack;
    },
    SEARCH_FILTER(state) {
      return state.search;
    },
    FROM_OC(state) {
      return state.fromoc;
    },
    BLOODBANK_CAMP_FILTER(state) {
      return state.bloodbankCampSearch;
    },
    BLOODBANK_REQUEST(state) {
      return state.bloodBankRequestBlood;
    },
    HOSPITAL_SEARCH(state) {
      return state.hospitalSearch;
    },
    APPOINTMENT_LISTING(state) {
      return state.appointmentListing;
    },
    DIAGNOSTIC_SEARCH(state) {
      return state.diagnosticSearch;
    }
  },
  mutations: {
    showLoading(state) {
      state.loading = true;
      state.themeLoader = 0;
      state.interval = setInterval(() => {
        if (state.themeLoader !== 100) {
          //clearInterval(state.interval);
          state.themeLoader += 25;
        }
      }, 2000);
    },

    setMicIndex(state, payload) {
      state.micIndex = payload;
    },
    hideLoading(state) {
      state.loading = false;
      clearInterval(state.interval);
      state.themeLoader = 0;
    },
    toggleLoading(state) {
      state.loading = !state.loading;
    },
    setSnack(state, snack) {
      state.snack.snackbar = snack.snackbar ? snack.snackbar : false;
      state.snack.message = snack.message ? snack.message : '';
    },
    setFromOC(state, fromoc) {
      state.fromoc = fromoc;
    },
    showOrderSummary(state, summary) {
      state.orderSummary = Object.assign({}, { ...summary });
    },
    setRedirectLogin(state, payload) {
      // router.push({
      //   name: "home",
      //   query: { redirectURL: payload },
      //   params: { loginFlag: true }
      // });
    },
    setCertificateNameStatus(state, payload) {
      state.certificateNameStatus = payload;
    },
    setLoadingGIF(state, payload) {
      state.loadingGIF = payload;
    }
  },
  actions: {
    showLoading(context) {
      context.commit("showLoading");
    },
    hideLoading(context) {
      context.commit("hideLoading");
    },
    toggleLoading(context) {
      context.commit("toggleLoading");
    },
    setSnack(context, payload) {
      context.commit("setSnack", payload);
    },
    setFromOC(context, payload) {
      context.commit("setFromOC", payload);
    },
    showOrderSummary({ commit }, payload) {
      commit("showOrderSummary", payload);
    }
  }
};
